import Search from '@mui/icons-material/Search'
import {EntryDescButton} from "module/edesc/component/EntryDescButton";
import React, {KeyboardEvent, useCallback, useRef} from "react";
import {components, PlaceholderProps} from 'react-select';
import './EntryDescSelectPlaceholder.css';
import {EntryDesc} from 'generated/JavaTOmodifications'
import {EntryDescCustomProps} from 'module/edesc/component/EntryDescCustomProps'
import {log} from 'common/log'

// the fade out element '.EntryDescSelectPlaceholderFader' does prevent select for touch events

export function EntryDescFavSelectPlaceholder(props: PlaceholderProps<EntryDesc, false> & { selectProps: EntryDescCustomProps }) {
	const ref = useRef<HTMLDivElement>(null);
	const {entryDescShortcuts, setEntryDesc, entryDescFavEditMode, toggleEntryDescFav} = props.selectProps;
	const sendKeypressToInput = useCallback((e: KeyboardEvent) => {
		if (ref.current && e.key.match(/^[A-Za-z0-9]$/)) {
			// focus input when user started search
			ref.current.parentElement?.parentElement?.querySelector('input')?.focus();
		}
	}, [ref.current])
	return (
		<components.Placeholder {...props} className={'EntryDescSelectPlaceholderWrapper'}>
			<div
				ref={ref}
				className="EntryDescSelectPlaceholder"
				onKeyDownCapture={sendKeypressToInput}
			>
				{entryDescShortcuts.map(ed => {
						const selectHandler = () => {
							setTimeout(() => {
								// timeout to fix touch events
								// this prevents drop down from opening (combined with ReactSelect.blurInputOnSelect = true)
								if (entryDescFavEditMode) {
									toggleEntryDescFav({entryDescId: ed.id, forceAdd: true});
								} else {
									setEntryDesc(ed);
								}
							}, 20);
						};
						return (
							<EntryDescButton
								key={"EntryDescButton" + ed.id}
								onClick={selectHandler}
								onTouchStart={selectHandler}
								entryDesc={ed}
								tabIndex={0}
							/>
						);
					},
				)}
			</div>
			<div className="EntryDescSelectPlaceholderFaderLeft"/>
			<div className="EntryDescSelectPlaceholderFaderRight"/>
			<Search className={'EntryDescSelectInputIcon'}/>
		</components.Placeholder>
	);
}